import React from 'react';
import { renderToString } from 'react-dom/server';
import {
    ColorIndicator,
    MetricName,
    ToolTipTitle, TooltipWholeText,
} from '@shared/components/tooltips/segmented-tooltip/segmented-tooltip.styles';

export const SegmentsGraphTooltip = () => (curveProperties) => {
    const [firstMetric] = curveProperties;

    return renderToString(
        <TooltipWholeText>
            <ToolTipTitle>
                {firstMetric.axisValue}
            </ToolTipTitle>
            {curveProperties.map(metric => (
                <div key={`segmented-tooltip-metric-${metric.seriesName}`}>
                    <ColorIndicator color={metric.color} />
                    <MetricName>
                        {` ${metric.seriesName}: 
                        ${Number.isNaN(parseFloat(metric.value))
                    ? '0.00' : metric.value}`}
                    </MetricName>
                </div>
            ))}
        </TooltipWholeText>,
    );
};
